import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const SelectionSidebar = superstyled({
  name: 'SelectionPanel',
  slot: 'Sidebar',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '0 0 20rem',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flex: 'none',
      minHeight: '200px'
    }
  })
});

export const SelectionList = superstyled({
  name: 'SelectionPanel',
  slot: 'List',
  tag: Box,
  styles: () => ({
    overflow: 'auto'
  })
});

export const ButtonsContainer = superstyled({
  name: 'SelectionPanel',
  slot: 'ButtonsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});
